import { createStyles } from './style-object.es.js';
const camelLetterToPipeLetter = letter => "-".concat(letter.toLowerCase());
const camelToPipeCase = str => str.replace(/[A-Z]/g, camelLetterToPipeLetter);
function createStyleString() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const styles = createStyles(target);
  let style = "";
  for (const key in styles) {
    style += key.startsWith("--") ? key : camelToPipeCase(key);
    style += ": ".concat(styles[key], "; ");
  }
  return style;
}
export { createStyleString };